/** @format */

import React, { useState, useEffect } from "react";
import LabelInput from "./labelInput";
import { useFieldStackSpacing } from "./fieldStackContext";

const MonthYearField = ({
  label,
  trigger,
  errors,
  register,
  control,
  monthID,
  yearID,
  watch,
  setValue, // Added setValue to reset the month if needed
}) => {
  const isInFieldStack = useFieldStackSpacing();
  const allMonths = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const getYearOptions = () => {
    return Array.from({ length: currentYear - 1899 + 1 }, (_, i) => {
      const year = currentYear - i;
      return { value: year.toString(), label: year.toString() };
    });
  };

  const [yearOptions] = useState(getYearOptions());
  const [filteredMonths, setFilteredMonths] = useState(allMonths);

  const selectedYear = watch(yearID);
  const selectedMonth = watch(monthID);
  const monthError = errors?.[monthID];
  const yearError = errors?.[yearID];

  useEffect(() => {
    if (Number(selectedYear?.value) === currentYear) {
      setFilteredMonths(
        allMonths.filter((month) => Number(month.value) <= currentMonth)
      );
    } else {
      setFilteredMonths(allMonths);
    }
    if (selectedMonth && Number(selectedYear?.value) === currentYear) {
      if (Number(selectedMonth?.value) > currentMonth) {
        setValue(monthID, null); // Reset month selection
      }
    }
  }, [selectedYear, selectedMonth, currentYear]);

  return (
    <div className="tw-w-full">
      {label && <label className="tw-mb-2 tw-block tw-text-base tw-font-bold tw-text-dis-navy">{label}</label>}
      <div className="tw-flex tw-items-start tw-gap-2">
        <div className="tw-w-3/5">
          <LabelInput
            id={monthID}
            type="select"
            options={filteredMonths}
            control={control}
            placeholder="Month"
            register={{
              ...register(monthID, { required: true }),
            }}
            watch={watch(monthID)} // Ensure month updates correctly
            trigger={trigger}
            errors={monthError}
          />
        </div>
        <div className="tw-w-2/5">
          <LabelInput
            id={yearID}
            type="select"
            options={yearOptions}
            control={control}
            placeholder="Year"
            register={{
              ...register(yearID, { required: true }),
            }}
            watch={watch(yearID)} // Ensure month updates correctly
            trigger={trigger}
            errors={yearError}
          />
        </div>
      </div>
    </div>
  );
};

export default MonthYearField;
